import _slicedToArray from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _classCallCheck from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/createClass.js";
export var DefaultIdentityProviderConfig = /*#__PURE__*/function () {
  function DefaultIdentityProviderConfig(config) {
    _classCallCheck(this, DefaultIdentityProviderConfig);
    this.authSchemes = new Map();
    for (var _i = 0, _Object$entries = Object.entries(config); _i < _Object$entries.length; _i++) {
      var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
        key = _Object$entries$_i[0],
        value = _Object$entries$_i[1];
      if (value !== undefined) {
        this.authSchemes.set(key, value);
      }
    }
  }
  _createClass(DefaultIdentityProviderConfig, [{
    key: "getIdentityProvider",
    value: function getIdentityProvider(schemeId) {
      return this.authSchemes.get(schemeId);
    }
  }]);
  return DefaultIdentityProviderConfig;
}();